import { Button, Progress } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";
import classes from "./SyncButton.module.css";

// POS senkronunu tetikleyen düğme. Sunucu kiracı başına bekleme uyguluyor (429) ve o süre boyunca
// düğme kilitli kalıyor.
//
// Kalan süre AYRI BİR YAZI olarak duruyordu ("108 sn"): kullanıcı hem düğmeye hem yanındaki sayıya
// bakmak zorundaydı ve sayı ancak okununca bir şey söylüyordu. Şimdi düğmenin KENDİSİ doluyor.
//
// Dolgu boşalmıyor, DOLUYOR: çubuk tamamlandığında düğme yeniden basılabilir oluyor. Ters yön
// (boşalan çubuk) bittiğinde "tükendi" izlenimi veriyordu.
//
// Kendi <Box> çubuğum yerine Progress: ekran okuyucuya `role="progressbar"` ve yüzdeyi kendisi
// veriyor, düz bir renkli kutu bunu söyleyemezdi.
export function SyncButton({
  mutation,
  cooldown = 0,
  total,
  label = "Yenile",
}) {
  const progress =
    total > 0 ? Math.max(0, Math.min(1, 1 - cooldown / total)) : 1;

  return (
    <Button
      variant="default"
      size="sm"
      leftSection={<IconRefresh size={16} />}
      loading={mutation?.isPending}
      disabled={cooldown > 0}
      onClick={() => mutation?.mutate()}
      className={classes.button}
    >
      <span className={classes.label}>{label}</span>
      {cooldown > 0 && (
        <Progress
          aria-label="Yenilemeye kalan süre"
          value={progress * 100}
          color="chocolate.2"
          radius={0}
          className={classes.progress}
          // Sayaç saniyede bir tikliyor; geçişsiz çubuk adım adım sıçrıyordu.
          transitionDuration={1000}
        />
      )}
    </Button>
  );
}
